import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';

export default function Edit({ attributes, setAttributes }) {
    const { id_titre_1Texte, id_titre_1CouleurTexte, id_titre_1Opacite, id_titre_1Afficher, id_sous_titre_1Texte, id_sous_titre_1CouleurTexte, id_sous_titre_1Opacite, id_sous_titre_1Afficher, id_paragraphe_1Texte, id_paragraphe_1CouleurTexte, id_paragraphe_1Opacite, id_paragraphe_1Afficher, id_paragraphe_2Texte, id_paragraphe_2CouleurTexte, id_paragraphe_2Opacite, id_paragraphe_2Afficher, id_bouton_1Texte, id_bouton_1Url, id_bouton_1CouleurFond, id_bouton_1CouleurTexte, id_bouton_1CouleurBordure, id_bouton_1CouleurFondHover, id_bouton_1CouleurTexteHover, id_bouton_1CouleurBordureHover, id_bouton_1CouleurFondActive, id_bouton_1CouleurTexteActive, id_bouton_1CouleurBordureActive, id_bouton_1Opacite, id_bouton_1Afficher, id_bouton_1_texte_1Texte, id_bouton_1_texte_1CouleurTexte, id_bouton_1_texte_1Opacite, id_bouton_1_texte_1Afficher, id_bouton_2Texte, id_bouton_2Url, id_bouton_2CouleurFond, id_bouton_2CouleurTexte, id_bouton_2CouleurBordure, id_bouton_2CouleurFondHover, id_bouton_2CouleurTexteHover, id_bouton_2CouleurBordureHover, id_bouton_2CouleurFondActive, id_bouton_2CouleurTexteActive, id_bouton_2CouleurBordureActive, id_bouton_2Opacite, id_bouton_2Afficher, id_bouton_2_texte_1Texte, id_bouton_2_texte_1CouleurTexte, id_bouton_2_texte_1Opacite, id_bouton_2_texte_1Afficher, id_image_1Id, id_image_1Alt, id_image_1Opacite, id_image_1Afficher, blocCouleurFond, blocCouleurBordure, blocImageFondId, animCode } = attributes;

    // Récupération dynamique et réactive des URLs avec useSelect
    const { imageUrl, id_image_1ImageUrl } = useSelect( ( select ) => {
        const media = select( 'core' );
        return {
            imageUrl: blocImageFondId ? media.getMedia( blocImageFondId )?.source_url : null,
            id_image_1ImageUrl: id_image_1Id ? media.getMedia( id_image_1Id )?.source_url : null
        };
    }, [ blocImageFondId, id_image_1Id ] );

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = imageUrl 
        ? { 
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{`
        .id_bouton_1:hover {
            background-color: ${id_bouton_1CouleurFondHover} !important;
            color: ${id_bouton_1CouleurTexteHover} !important;
            border-color: ${id_bouton_1CouleurBordureHover} !important;
        }
        .id_bouton_1:active {
            background-color: ${id_bouton_1CouleurFondActive} !important;
            color: ${id_bouton_1CouleurTexteActive} !important;
            border-color: ${id_bouton_1CouleurBordureActive} !important;
        }
        .id_bouton_2:hover {
            background-color: ${id_bouton_2CouleurFondHover} !important;
            color: ${id_bouton_2CouleurTexteHover} !important;
            border-color: ${id_bouton_2CouleurBordureHover} !important;
        }
        .id_bouton_2:active {
            background-color: ${id_bouton_2CouleurFondActive} !important;
            color: ${id_bouton_2CouleurTexteActive} !important;
            border-color: ${id_bouton_2CouleurBordureActive} !important;
        }`}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {imageUrl ? (
                                        <div>
                                            <img src={imageUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="sous-titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_sous_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_sous_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_sous_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_sous_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_sous_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_sous_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-2 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_2Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_2Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_2CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_2CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_2Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bouton-1 (Bouton)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_bouton_1Afficher}
                        onChange={(val) => setAttributes({ id_bouton_1Afficher: val })}
                    />
                    <BaseControl label="URL du bouton">
                        <URLInput
                            value={id_bouton_1Url}
                            onChange={(url) => setAttributes({ id_bouton_1Url: url })}
                            isFullWidth
                        />
                    </BaseControl>
                    
                    <h4>État Normal</h4>
                    <BaseControl label="Couleur de fond">
                        <ColorPalette value={id_bouton_1CouleurFond} onChange={(val) => setAttributes({ id_bouton_1CouleurFond: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte">
                        <ColorPalette value={id_bouton_1CouleurTexte} onChange={(val) => setAttributes({ id_bouton_1CouleurTexte: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette value={id_bouton_1CouleurBordure} onChange={(val) => setAttributes({ id_bouton_1CouleurBordure: val })} />
                    </BaseControl>
                    
                    <h4>État Hover</h4>
                    <BaseControl label="Couleur de fond (Hover)">
                        <ColorPalette value={id_bouton_1CouleurFondHover} onChange={(val) => setAttributes({ id_bouton_1CouleurFondHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Hover)">
                        <ColorPalette value={id_bouton_1CouleurTexteHover} onChange={(val) => setAttributes({ id_bouton_1CouleurTexteHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Hover)">
                        <ColorPalette value={id_bouton_1CouleurBordureHover} onChange={(val) => setAttributes({ id_bouton_1CouleurBordureHover: val })} />
                    </BaseControl>
                    
                    <h4>État Active</h4>
                    <BaseControl label="Couleur de fond (Active)">
                        <ColorPalette value={id_bouton_1CouleurFondActive} onChange={(val) => setAttributes({ id_bouton_1CouleurFondActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Active)">
                        <ColorPalette value={id_bouton_1CouleurTexteActive} onChange={(val) => setAttributes({ id_bouton_1CouleurTexteActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Active)">
                        <ColorPalette value={id_bouton_1CouleurBordureActive} onChange={(val) => setAttributes({ id_bouton_1CouleurBordureActive: val })} />
                    </BaseControl>
                    
                    <RangeControl
                        label="Opacité"
                        value={id_bouton_1Opacite}
                        onChange={(val) => setAttributes({ id_bouton_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_bouton_1_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_bouton_1_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_bouton_1_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_bouton_1_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_bouton_1_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_bouton_1_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bouton-2 (Bouton)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_bouton_2Afficher}
                        onChange={(val) => setAttributes({ id_bouton_2Afficher: val })}
                    />
                    <BaseControl label="URL du bouton">
                        <URLInput
                            value={id_bouton_2Url}
                            onChange={(url) => setAttributes({ id_bouton_2Url: url })}
                            isFullWidth
                        />
                    </BaseControl>
                    
                    <h4>État Normal</h4>
                    <BaseControl label="Couleur de fond">
                        <ColorPalette value={id_bouton_2CouleurFond} onChange={(val) => setAttributes({ id_bouton_2CouleurFond: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte">
                        <ColorPalette value={id_bouton_2CouleurTexte} onChange={(val) => setAttributes({ id_bouton_2CouleurTexte: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette value={id_bouton_2CouleurBordure} onChange={(val) => setAttributes({ id_bouton_2CouleurBordure: val })} />
                    </BaseControl>
                    
                    <h4>État Hover</h4>
                    <BaseControl label="Couleur de fond (Hover)">
                        <ColorPalette value={id_bouton_2CouleurFondHover} onChange={(val) => setAttributes({ id_bouton_2CouleurFondHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Hover)">
                        <ColorPalette value={id_bouton_2CouleurTexteHover} onChange={(val) => setAttributes({ id_bouton_2CouleurTexteHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Hover)">
                        <ColorPalette value={id_bouton_2CouleurBordureHover} onChange={(val) => setAttributes({ id_bouton_2CouleurBordureHover: val })} />
                    </BaseControl>
                    
                    <h4>État Active</h4>
                    <BaseControl label="Couleur de fond (Active)">
                        <ColorPalette value={id_bouton_2CouleurFondActive} onChange={(val) => setAttributes({ id_bouton_2CouleurFondActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Active)">
                        <ColorPalette value={id_bouton_2CouleurTexteActive} onChange={(val) => setAttributes({ id_bouton_2CouleurTexteActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Active)">
                        <ColorPalette value={id_bouton_2CouleurBordureActive} onChange={(val) => setAttributes({ id_bouton_2CouleurBordureActive: val })} />
                    </BaseControl>
                    
                    <RangeControl
                        label="Opacité"
                        value={id_bouton_2Opacite}
                        onChange={(val) => setAttributes({ id_bouton_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_bouton_2_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_bouton_2_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_bouton_2_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_bouton_2_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_bouton_2_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_bouton_2_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="image-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_image_1Afficher}
                        onChange={(val) => setAttributes({ id_image_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_image_1Alt}
                            onChange={(val) => setAttributes({ id_image_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_image_1Opacite}
                        onChange={(val) => setAttributes({ id_image_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                <div className="row">
                    <div className="col-md-6 order-1 order-md-1 d-flex justify-content-center">
                        {/* id_image_1 */}
                        {id_image_1Afficher && (
                            <MediaUpload
                                onSelect={(media) => setAttributes({ id_image_1Id: media.id, id_image_1Alt: media.alt })}
                                type="image"
                                value={id_image_1Id}
                                render={({ open }) => (
                                    <div onClick={open} style={{ cursor: 'pointer' }}>
                                        {id_image_1ImageUrl ? (
                                            <img className="id_image_1" src={id_image_1ImageUrl} alt={id_image_1Alt} style={{ opacity: id_image_1Opacite }} />
                                        ) : (
                                            <Button variant="secondary">Ajouter une image</Button>
                                        )}
                                    </div>
                                )}
                            />
                        )}
                        {/* end-id_image_1 */}
                    </div>
                    <div className="col-md-6 order-2 order-md-2">
                        {/* id_titre_1 */}
                        {id_titre_1Afficher && (
                            <RichText 
                                tagName="h1" 
                                className="id_titre_1 " 
                                value={id_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_titre_1CouleurTexte, opacity: id_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_titre_1 */}
                        {/* id_sous_titre_1 */}
                        {id_sous_titre_1Afficher && (
                            <RichText 
                                tagName="h2" 
                                className="id_sous_titre_1 " 
                                value={id_sous_titre_1Texte} 
                                onChange={(val) => setAttributes({ id_sous_titre_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_sous_titre_1CouleurTexte, opacity: id_sous_titre_1Opacite }} 
                            />
                        )}
                        {/* end-id_sous_titre_1 */}
                        {/* id_paragraphe_1 */}
                        {id_paragraphe_1Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_paragraphe_1 " 
                                value={id_paragraphe_1Texte} 
                                onChange={(val) => setAttributes({ id_paragraphe_1Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_paragraphe_1CouleurTexte, opacity: id_paragraphe_1Opacite }} 
                            />
                        )}
                        {/* end-id_paragraphe_1 */}
                        {/* id_paragraphe_2 */}
                        {id_paragraphe_2Afficher && (
                            <RichText 
                                tagName="p" 
                                className="id_paragraphe_2 " 
                                value={id_paragraphe_2Texte} 
                                onChange={(val) => setAttributes({ id_paragraphe_2Texte: val })} 
                                placeholder="Saisir le texte..." 
                                style={{ color: id_paragraphe_2CouleurTexte, opacity: id_paragraphe_2Opacite }} 
                            />
                        )}
                        {/* end-id_paragraphe_2 */}
                        <div className="row">
                            {/* id_bouton_1 */}
                            <div className="col-12 col-md-auto">
                                {id_bouton_1Afficher && (
                                    <a 
                                        className="btn id_bouton_1"
                                        role="button"
                                        onClick={(e) => e.preventDefault()}
                                        style={{
                                            backgroundColor: id_bouton_1CouleurFond,
                                            color: id_bouton_1CouleurTexte,
                                            borderColor: id_bouton_1CouleurBordure,
                                            opacity: id_bouton_1Opacite,
                                            cursor: 'default'
                                        }}
                                    >
                                        <RichText
                                            tagName="span"
                                            value={id_bouton_1Texte}
                                            onChange={(val) => setAttributes({ id_bouton_1Texte: val })}
                                            placeholder="Texte du bouton..."
                                        />
                                    </a>
                                )}
                            </div>
                            {/* end-id_bouton_1 */}
                            {/* id_bouton_2 */}
                            <div className="col-12 col-md-auto">
                                {id_bouton_2Afficher && (
                                    <a 
                                        className="btn id_bouton_2"
                                        role="button"
                                        onClick={(e) => e.preventDefault()}
                                        style={{
                                            backgroundColor: id_bouton_2CouleurFond,
                                            color: id_bouton_2CouleurTexte,
                                            borderColor: id_bouton_2CouleurBordure,
                                            opacity: id_bouton_2Opacite,
                                            cursor: 'default'
                                        }}
                                    >
                                        <RichText
                                            tagName="span"
                                            value={id_bouton_2Texte}
                                            onChange={(val) => setAttributes({ id_bouton_2Texte: val })}
                                            placeholder="Texte du bouton..."
                                        />
                                    </a>
                                )}
                            </div>
                            {/* end-id_bouton_2 */}
                        </div>
                    </div>
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}